
import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TransactionService } from '../../../Services/transaction.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Utility } from '../../../Utilities/utility';
import { CookieService } from 'ngx-cookie-service';
import { NotificationService } from 'src/app/Services/notification.service';
@Component({
  selector: 'app-spra-request-list',
  templateUrl: './spra-request-list.component.html',
  styleUrls: ['./spra-request-list.component.css']
})
export class SpraRequestListComponent implements OnInit,AfterViewInit {

  public SpraListHeader: String[] = ["requestNo", "requestDate", "branch", "partyName","saleType", "enteredBy","isRental"];
  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  public IsCeha:boolean
  utility: Utility;
  constructor(
    private _TransactionService:TransactionService,
     private intl: MatPaginatorIntl,
     private changeDectector: ChangeDetectorRef,
     private router: Router,
     private route: ActivatedRoute,
     private _CookieService: CookieService
     ,private _NotificationService:NotificationService
    ) { 

      this.sort = new MatSort();
      this.paginator = new MatPaginator(this.intl, this.changeDectector);
      this.utility = new Utility(this._CookieService);
      this.IsCeha = false;
      this.route.params.subscribe((params) =>{
        
        if(params.IsCeha != undefined && params.IsCeha ==1){
          this.IsCeha = true;
        }
      });
      let param: any = this.router.getCurrentNavigation()?.extras.state;
    if (param) {     
      if (param.Message){
        this._NotificationService.showSuccess(param.Message,"");
      }
    }
    }

  ngOnInit(): void {
    this.GetSpraRequestListById();
  }


  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  GetSpraRequestListById(){
      this._TransactionService.GetAllSPRARequestList(0,this.IsCeha).subscribe((d:any)=>{
        this.dataSource.data = d;
        setTimeout(() => {
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        });
      },(error) => {                              //Error callback
        this.utility.Error(error);
      });
    
    
  }

  public doFilter = (event: any) => {
    this.dataSource.filter = event.target.value.trim().toLocaleLowerCase();
  }
  
  onRequestClick(row :any) {
    // this.route.navigate(['spra-view-data'], {
    this.router.navigate(['spra-service'], {
      state: {
        "SPRAId": row.id,
        "RefId": row.refId,
        "saleCode": row.saleCode,
        "officeId": row.officeID,
        "CompanyID": row.companyID,
        "IsCeha" : this.IsCeha //Added by rahul yadav on 7/6/2021 to redirect page sas or sbs
      }
    });

  }

  
 

}
